import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=a665b8bc"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a665b8bc')) {
      api.createRecord('a665b8bc', component.options)
    } else {
      api.reload('a665b8bc', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=a665b8bc", function () {
      api.rerender('a665b8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/Wrapper.vue"
export default component.exports